// eslint-disable-next-line import/no-named-as-default
import gql from 'graphql-tag';

export const FIND_CONFIGURATOR = gql`
  query Plans($decorId: String, $id: ID) {
    findConfigurator(decorId: $decorId, id: $id)
  }
`;

export const FIND_PHOTOS = gql`
  query Plans($decorId: String, $id: ID) {
    findPhotos(decorId: $decorId, id: $id)
  }
`;

export const CONTRACTORS = gql`
  query Contractors {
    contractors {
      id
      name
      ceo
      logo
    }
  }
`;

export const CONTRACTOR = gql`
  query Contractors($id: ID!) {
    contractor(id: $id) {
      id
      name
      ceo
      phone
      email
      webSite
      about
      logo
      photos
      recommendedBy
      templateId
      specifications
    }
  }
`;

export const CONTRACTOR_VIEW = gql`
  query Contractors($id: ID!) {
    contractor(id: $id) {
      id
      about
      photos
      recommendedBy
      templateId
    }
  }
`;

export const TEMPLATES = gql`
  query Templates {
    templates {
      id
      title
      typeformId
      link
    }
  }
`;

export const TEMPLATE = gql`
  query Templates($id: ID!) {
    template(id: $id) {
      id
      title
      typeformId
      link
      specifications
    }
  }
`;

export const PLAN_RECOMMENDATION = gql`
  query Plans($id: ID!) {
    recommendation(id: $id) {
      id
      title
      image
    }
  }
`;

export const PLANS = gql`
  query Plans(
    $contractorId: String! = ""
    $isHidden: Boolean! = false
    $meta: JSON
    $lastViewed: String
    $state: String
    $county: String
    $city: String
  ) {
    plans(
      contractorId: $contractorId
      isHidden: $isHidden
      meta: $meta
      lastViewed: $lastViewed
      state: $state
      county: $county
      city: $city
    ) {
      id
      title
      contractorId
      url
      decorId
      image
      templateId
      specifications
      isHidden
      meta
      planSVG
      planId
      available
      photos
    }
  }
`;

export const GUEST_PLANS = gql`
  query Plans($meta: JSON) {
    guestPlans(meta: $meta) {
      id
      title
      contractorId
      url
      decorId
      image
      templateId
      specifications
      isHidden
      meta
      planSVG
      planId
      available
    }
  }
`;

export const PLAN = gql`
  query Plans($id: ID!) {
    plan(id: $id) {
      id
      title
      contractorId
      description
      url
      image
      templateId
      specifications
      photos
      isHidden
      meta
      decorId
      planSVG
      planId
      hasARModel
      planCost
      isModular
      isManufactured
      preApproved
      fixPrice
      sourcePlan
      available
    }
  }
`;

export const PLAN_VIEW = gql`
  query Plans($id: ID!) {
    plan(id: $id) {
      id
      contractorId
      url
      image
      photos
      meta
      specifications
      planSVG
      planId
      hasARModel
      planCost
      isModular
      isManufactured
      preApproved
      fixPrice
      available
    }
  }
`;

export const ASSISTANT_CHATS = gql`
  query AssistantChat {
    assistantChats {
      id
      email
      name
    }
  }
`;

export const ASSISTANT_CHAT = gql`
  query AssistantChat($id: ID!) {
    assistantChat(id: $id) {
      id
      email
      name
      messages
      plans
    }
  }
`;

export const USERS = gql`
  query User {
    users {
      id
      isVerified
      name
      email
      role
    }
  }
`;

export const USER = gql`
  query User($id: ID!) {
    user(id: $id) {
      id
      isVerified
      name
      email
      role
      createdAt
    }
  }
`;

export const MAP_RESULT = gql`
  query MapResults($id: ID!) {
    mapResult(id: $id) {
      id
      map
      snapshot
      plan
      user
    }
  }
`;

export const MAP_RESULTS = gql`
  query MapResults {
    mapResults {
      id
      map
      snapshot
      plan
      user
    }
  }
`;

export const MAP_USER_RESULTS = gql`
  query MyMapResults($user: ID!) {
    mapUserResults(user: $user) {
      id
      map
      snapshot
      plan
      user
      meta
      photos
      planSVG
      planTitle
    }
  }
`;

export const GET_SUMMARY = gql`
  query Summary($id: ID!) {
    getSummary(id: $id) {
      data
    }
  }
`;

export const GET_ALL_PRODUCTS_OF_CONFIGURATORS = gql`
  query ProductsOfConfigurators {
    productsOfConfigurators {
      list
    }
  }
`;

export const FLUX_GENERATIONS = gql`
  query FluxGeneration {
    fluxGenerations {
      id
      status
      planId
      sourceImage
      data
      sqsMessageId
      createdAt
      updatedAt
      executionTime
    }
  }
`;

export const FLUX_GENERATIONS_BY_PLAN_ID = gql`
  query FluxGeneration($planId: ID!) {
    fluxGenerationByPlanId(planId: $planId) {
      id
      status
      planId
      sourceImage
      data
      sqsMessageId
      createdAt
      updatedAt
      executionTime
    }
  }
`;

export const DIRECTORY = gql`
  query Directory($id: ID, $slug: String) {
    directory(id: $id, slug: $slug) {
      id
      name
      slug
      values {
        id
        name
        description
        directory
      }
    }
  }
`;

export const DIRECTORIES_VALUES_BY_IDS = gql`
  query DirectoriesValuesByIds($ids: [ID!]!) {
    directoriesValuesByIds(ids: $ids) {
      id
      name
      description
      directory
    }
  }
`;

export const DIRECTORIES = gql`
  query Directory {
    directories {
      id
      name
      slug
    }
  }
`;
